import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MuiAlert from '@material-ui/lab/Alert';
import Configuration from '../../service/configuration';
import Resources from '../../service/resources';
import DataServices from '../../service/data-services';
import {
    Snackbar,
    Grid,
    AppBar,
    Tabs,
    Tab,
    LinearProgress,
    Button,
    TextField,
    IconButton,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Typography,
  Avatar,
  Chip,
    TableContainer,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    FormControl,} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Close, GetApp, FilterList, LocalShipping as LocalShippingIcon, AttachMoney as AttachMoneyIcon} from '@material-ui/icons';
import AuditLogsTable from './AuditLogsTable';
import moment from 'moment';
import { DateTimePicker, MuiPickersUtilsProvider, KeyboardDatePicker, } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { green, orange } from '@material-ui/core/colors';
import SimpleSearchToolbar from '../../components/SimpleSearchToolbar';
import { useTranslation, withTranslation } from 'react-i18next'


class AuditLogs extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: 0,
            contentList : null,
            totalRecords: 0,
            rowsPerPage: 10,
            first: 0,
            max: 10,
            keyword:'',
            orderBy:'created_on',
            asc:false,
            errors:{ errorMessage:'', error:false, description:null},
            message: false,
            dialogMessage:'',
            loading: false,
            dialogOpen: false,
            search:{
                first: 0,
                max: 10,
                orderBy: 'id',
                asc: false,
                startDate: null,
                endDate: null,
                branchGuid: null,
                keyword: '',
            },
            contentEdit:{
                guid: null,
                description: '',
                approverGuid: null,
            },
            employeeList : [],
            employeeSelected : null,
            zoneList : [],
            zoneSelected : null,
            statusList:[{name:'On hand',value:'On hand'},{name:'Clear',value:'Clear'}],
            statusSelected: {name:'On hand',value:'On hand'},
            totalCollected:0.0,
            totalWays:0,
            selectedItem:null,
        };

        this.config = new Configuration( );
        this.dataService = new DataServices( );
        this.resources = new Resources( );
        this.onChangePage = this.onChangePage.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onClick = this.onClick.bind(this);
        this.auth = null;
        this.userData = null;
        this.t = this.props.lang;
        this.i18n = this.props.i18n;
    }

    onChangePage( first, max, keyword, asc ){
        this.state.rowsPerPage = max;
        this.state.search.first=first;
        this.state.search.max = max;
        this.state.search.orderBy = keyword;
        this.state.search.asc = asc;

        this.getContentList( );
        this.dataService.setRowPerPage(max);
    }

    onSubmit( keyword ){
        this.state.search.keyword = keyword;
        this.state.search.first =  0;
        this.getContentList( );
    }

    onClick(item, mode){
        this.state.contentEdit.guid = item.guid;
        this.setState({selectedItem:item, dialogOpen: true});
    }

    render() {
        return (
            <div>
            <Card>
                <CardHeader
                    title={'Audit logs'}
                    subheader={'The event trigger logs for all users.'}
                    action={
                      <IconButton aria-label="settings"
                        onClick={event => this.onDownload()}>
                        < GetApp color="primary"/>
                      </IconButton>
                    } />
                <CardContent>

                    <Grid container spacing={1} >
                    <Grid item md={12} xs={12} >
                        <SimpleSearchToolbar onSubmit={this.onSubmit} />
                    </Grid>

                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                        <Grid item md={6} xs={6} >
                           <KeyboardDatePicker
                                autoOk
                               variant="inline"
                               format="yyyy-MM-dd"
                               margin="dense"
                               id="date-picker-inline"
                               label="Start Date"
                               value={this.state.search.startDate}
                               KeyboardButtonProps={{ 'aria-label': 'change date',width:'100%'}}
                               onChange={ (event) => {
                                this.setState(Object.assign(this.state.search, {['startDate']: event}));
                                this.getContentList( );
                               } } />
                        </Grid>

                        <Grid item md={6} xs={6}  >
                           <KeyboardDatePicker
                                autoOk
                               variant="inline"
                               format="yyyy-MM-dd"
                               margin="dense"
                               id="date-picker-inline"
                               label="End Date"
                               value={this.state.search.endDate}
                               KeyboardButtonProps={{ 'aria-label': 'change date',width:'100%'}}
                               onChange={ (event) => {
                                this.setState(Object.assign(this.state.search, {['endDate']: event}));
                                this.getContentList( );
                           } } />
                        </Grid>
                        </MuiPickersUtilsProvider>

                        {/*
                        <Grid item md={2} xs={6} style={{marginTop:'1%'}} >
                            <Button variant="contained"  onClick={event => this.getContentList()} color="primary" style={{textTransform: 'capitalize'}}>
                              Search
                            </Button>
                        </Grid>
                        */}
                    </Grid>
                    {/*<SearchToolbar onSubmit={this.onSubmit} /> */}
                    { this.state.contentList &&
                    <div style={{marginTop: 12}}>
                        <AuditLogsTable
                            contentList={this.state.contentList}
                            onClick={this.onClick}
                            defaultRowsPerPage={this.state.rowsPerPage}
                            defaultPage={0}
                            totalRecords={this.state.totalRecords}
                            onChangePage={this.onChangePage}
                        />
                    </div>
                    }
                </CardContent>
                {this.state.loading && <LinearProgress />}
            </Card>

                <Snackbar open={this.state.message} autoHideDuration={3000}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    onClose={ ( event ) => {
                        this.setState({message:false});
                        this.getContentList( );
                    }}>
                    <MuiAlert severity="success" elevation={6} variant="filled"
                    onClose={ ( event ) => {
                        this.setState({message:false});
                        this.getContentList( );
                    }}>
                      {this.state.dialogMessage}
                    </MuiAlert>
                </Snackbar>

                 <Snackbar open={this.state.errors.error} autoHideDuration={6000}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                     onClose={ ( event ) => {
                       this.state.errors.error = false;
                       this.state.errors.errorMessage = null;
                       this.setState({loading: false});
                     }}>
                    <MuiAlert severity="error" elevation={6} variant="filled"
                        onClose={ ( event ) => {
                          this.state.errors.error = false;
                          this.state.errors.errorMessage = null;
                          this.setState({loading: false});
                        }}>
                      {this.state.errors.errorMessage}
                    </MuiAlert>
                </Snackbar>

            </div>
        );
    }

    componentDidMount() {
        this.i18n.changeLanguage(this.dataService.getLanguage());
        this.state.rowsPerPage = parseInt( this.dataService.getRowPerPage(), 10);
        this.state.max = this.state.rowsPerPage;
        this.auth = this.dataService.getAuthoritiesData( );
        this.userData = this.dataService.getCurrentUserData();
        this.state.search.branchGuid = this.userData['branchGuid'];
        this.getContentList( );
    }

    getContentList( ) {

        if(this.state.search.startDate){
         this.setState(Object.assign(this.state.search,{'startDate' :  moment(this.state.search.startDate).format('YYYY-MM-DD')}));
        }
        if(this.state.search.endDate){
         this.setState(Object.assign(this.state.search,{'endDate' :  moment(this.state.search.endDate).format('YYYY-MM-DD')}));
        }
        this.setState({
            loading: true
        });


        this.dataService.retrievePOST( this.state.search,
        this.config.SERVICE_NAME_AUDIT_LOGS + this.config.SERVICE_ACTION_AUDIT_LOGS_LIST).then(items => {

            if(items) {
                if( items.success){
                    this.setState({
                        contentList: items.data.items,
                        totalRecords: items.data.totalRecords,
                        loading: false
                    });
                }else{
                    this.state.errors.error = true;
                    this.state.errors.errorMessage = this.config.MESSAGE_REQUEST_TIMEOUT;
                    this.setState({loading:false});
                }
            }else{
                this.state.errors.error = true;
                this.state.errors.errorMessage = this.config.MESSAGE_REQUEST_TIMEOUT;
                this.setState({loading:false});
            }
        });
    }
}

//export default PromoCode;
export default (props) => {
    const { t, i18n } = useTranslation();
    return (<AuditLogs lang={t} i18n={i18n} props{... props} />)
}
